import { Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Paper, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { DateCalendar, LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react'
import { data, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ApiDeleteAllocation, ApiGetAllocations, ApiGetAppliedAllocations, ApiGetVisitTimes, ApiResetAllocation, ApiUpdateDateTime } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';

function AllocationDetails() {
    const [allocationdetials, setallocationdetails] = useState<any>([]);
    const [startDate, setStartDate] = useState<any>(dayjs());
    const [visittimes, setvisittimes] = useState<any>([]);
    const [selectedVisitTime, setselectedVisitTime] = useState<any>(allocationdetials ? allocationdetials?.selectedVisitTime?.visitTimeId : 0);
    const { allocationId } = useParams()
    const userId = localStorage.getItem('userId')
    const navigate = useNavigate()


    const getallocations = async () => {
        try {
            const data = `?allocationId=${allocationId}`
            const res = await ApiGetAppliedAllocations(data)
            setallocationdetails(res.data)
            setselectedVisitTime(res.data[0]?.selectedVisitTime?.visitTimeId)
            setStartDate(dayjs((res.data[0]?.selectedVisitDate)?.split('T')[0]))
        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {

        allocationId && getallocations()
    }, [allocationId])

    useEffect(() => {
        const gettimes = async () => {

            try {
                const res = await ApiGetVisitTimes()
                setvisittimes(res.data)
            } catch (error) {

            }
        }
        gettimes()
    }, [])



    // console.log("Visist Times", visittimes);



    //     const shouldDisableDate = (
    //     date: Dayjs,
    //     activeMonth: any,
    //     activeYear: any,
    //     startDay: any,
    //     endDay: any,
    //     visitDaysString: string
    //   ) => {
    //     // Convert visitDaysInformation to an array
    //     const allowedDays = visitDaysString.split(", ").map((day) => day.trim());

    //     // Get full day name (e.g., "Monday")
    //     const dayName = date.format("dddd");

    //     // Disable if the day is NOT in the allowedDays array
    //     if (!allowedDays.includes(dayName)) {
    //       return true;
    //     }

    //     // Disable dates outside the active month and year
    //     if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
    //       return true;
    //     }

    //     // Disable dates outside the given range
    //     if (date.date() < startDay || date.date() > endDay) {
    //       return true;
    //     }

    //     // 6. New Condition ➡️ Block same weekday as lastJobVisitedDate
    //     if (
    //       allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
    //       allocationCriteria?.lastJobVisitedDate
    //     ) {
    //       const lastVisitedDayName = dayjs(
    //         allocationCriteria.lastJobVisitedDate
    //       ).format("dddd"); // Get day name from last visited date
    //       if (dayName === lastVisitedDayName) {
    //         return true; // Block this date
    //       }
    //     }

    //     // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
    //     if (
    //       allocationCriteria?.minDaysGapBetweenJobs &&
    //       allocationCriteria?.lastJobVisitedDate
    //     ) {
    //       const gapRequired = allocationCriteria.minDaysGapBetweenJobs;
    //       const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);
    //       const minAllowedDate = lastVisitDate.add(gapRequired, "day"); // Add required gap

    //       if (date.isBefore(minAllowedDate, "day")) {
    //         return true; // Block dates before (lastVisitDate + gap days)
    //       }
    //     }
    //   };
    // console.log(allocationdetials)
    const handleUpdateAppliedAllocation = async () => {
        const data = {
            appliedAllocationId: parseInt(allocationdetials[0].appliedAllocationId),
            selectedVisitDate: startDate.format('YYYY-MM-DD'),
            selectedVisitTime: parseInt(selectedVisitTime),
        }
        try {
            const res = await ApiUpdateDateTime(data)
            toast.success(res.data)
            getallocations()

        } catch (error) {
            alert(error)
        }
    }
    const handleResetAllocation = async () => {
        const data = `?allocationId=${allocationId}&userId=${allocationdetials[0]?.userId?.userId}`
        // const data = `?allocationId=${allocationId}&userId=${userId}`
        // console.log("ResetData", data)
        try {
            const res = await ApiResetAllocation(data)
            navigate('/admin/allocations/monthly-calendar')
            toast.success(res.data)
            getallocations()

        } catch (error) {
            alert(error)
        }
    }
    const handleDeleteAllocation = async () => {
        const data = `?allocationId=${allocationId}`
        // console.log("DeleteData", data)
        try {
            const res = await ApiDeleteAllocation(data)
            navigate('/admin/allocations/monthly-calendar')
            toast.success(res.data)
            getallocations()

        } catch (error) {
            alert(error)
        }
    }

    return (
        <div style={{ backgroundColor: "white", padding: "20px" }}>
            <Typography variant='h4' className='text-center'>Allocation Details { }</Typography>
            <Box className='d-flex mt-3 extra align-items-center justify-content-end' gap={2}>
                <Button
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                    onClick={() => handleResetAllocation()}
                >
                    Reset
                </Button>
                <Button
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                    onClick={() => handleDeleteAllocation()}>
                    Delete
                </Button>

            </Box>
            <Box className="mt-3">
                <Box border='1px solid black' borderRadius='10px' className='px-1'>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Venue Name</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{allocationdetials[0]?.allocationId.venueId?.venueName}</Typography>
                        </Box>

                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Group Code</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{allocationdetials[0]?.allocationId?.allocationClientGroup}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Hotel Type</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{allocationdetials[0]?.allocationId?.venueId?.shopTypeId?.shopTypeName}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Venue Address</Typography>
                        </Box>
                        <Box className='py-3 px-2'>
                            <Typography gutterBottom><span style={{ fontWeight: "bold" }}>Address: </span>{allocationdetials[0]?.allocationId?.venueId?.address}</Typography>
                            <Typography gutterBottom><span style={{ fontWeight: "bold" }}>PostCode: </span>{allocationdetials[0]?.allocationId?.venueId?.postalCode}</Typography>
                            <Typography gutterBottom><span style={{ fontWeight: "bold" }}>Trade hours: </span>{allocationdetials[0]?.allocationId?.venueId?.tradingHours}</Typography>
                            <Typography ><span style={{ fontWeight: "bold" }}>Website: </span>{allocationdetials[0]?.allocationId?.venueId?.websiteURL}</Typography>
                        </Box>

                    </Box>
                    {/* <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Month Change</Typography>
                        </Box>
                        <TextField className='w-100 p-2'
                            // value={{allocationdetials[0].}}
                            sx={{
                                ".MuiOutlinedInput-input ": {
                                    padding: '8px'
                                },
                            }}
                        ></TextField>
                    </Box> */}
                    {/* <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Date Change</Typography>
                        </Box>
                        <TextField className='w-100 p-2'
                            sx={{
                                ".MuiOutlinedInput-input ": {
                                    padding: '8px'
                                },
                            }}
                        ></TextField>
                    </Box> */}
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Visit Date</Typography>
                        </Box>
                        <Box className='d-flex extra justify-content-start px-2'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <StaticDatePicker

                                    // shouldDisableDate={(date) =>
                                    //     shouldDisableDate(
                                    //         date,
                                    //         allocationdetials[0]?.allocationId?.jobMonth,
                                    //         allocationdetials[0]?.allocationId?.jobYear,
                                    //         allocationdetials[0]?.allocationId?.minDate,
                                    //         allocationdetials[0]?.allocationId?.maxDate,
                                    //         allocationdetials[0]?.allocationId?.visitDaysInformation
                                    //     )
                                    // }
                                    sx={{
                                        "& .MuiPickersCalendarHeader-switchViewButton":
                                        {
                                            // display: "none",
                                        },
                                        "& .MuiPickersArrowSwitcher-root": {
                                            // display: "none",
                                        },
                                        "& .MuiPickersDay-root.Mui-selected": {
                                            backgroundColor: "#ADB792 !important",
                                            borderRadius: '10px'
                                        },
                                        "& .MuiPickersCalendarHeader-labelContainer":
                                        {
                                            pointerEvents: "none",
                                        },
                                    }}
                                    className='m-0' onChange={(newValue) => setStartDate(newValue)} value={startDate} />
                            </LocalizationProvider>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                        <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Visit Time</Typography>
                        </Box>
                        <Box className='px-2' >

                            {selectedVisitTime > 0 && 
                            <FormControl key={selectedVisitTime}>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    row
                                    defaultValue={allocationdetials[0]?.selectedVisitTime?.visitTimeId}
                                    value={selectedVisitTime ?? allocationdetials[0]?.selectedVisitTime?.visitTimeId}
                                    onChange={(e) => { setselectedVisitTime(e.target.value) }}
                                    name="radio-buttons-group"
                                >
                                    {visittimes.length > 0 && visittimes.map((item: any, index: number) => (
                                        <FormControlLabel value={item.visitTimeId} control={<Radio />} label={item?.visitTimeInformation} />
                                    ))}
                                </RadioGroup>
                            </FormControl>}


                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Shopper Name</Typography>
                        </Box>
                        <Box className='py-3 px-2'>
                            <Button variant='outlined' className='mb-1' sx={{ color: 'black', borderColor: 'black' }}>{allocationdetials[0]?.userId?.firstName}&nbsp;{allocationdetials[0]?.userId?.lastName}</Button>
                            <Typography gutterBottom><span style={{ fontWeight: "bold" }}>Email: </span>{allocationdetials[0]?.userId?.emailId} </Typography>
                            <Typography gutterBottom><span style={{ fontWeight: "bold" }}>Mob: </span> {allocationdetials[0]?.userId?.contactNo}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Check In Date</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{(allocationdetials[0]?.allocationId?.checkInDateTime)?.split('T')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Check In Time</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{((allocationdetials[0]?.allocationId?.checkInDateTime)?.split('T')[1])?.split('.')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Check In Location</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>static</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Checkout Date</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{(allocationdetials[0]?.allocationId?.checkOutDateTime)?.split('T')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Checkout Time</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>{((allocationdetials[0]?.allocationId?.checkOutDateTime)?.split('T')[1])?.split('.')[0]}</Typography>
                        </Box>
                    </Box>
                    <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Checkout Location</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>Static</Typography>
                        </Box>
                    </Box>
                    {/* <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                        <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                            <Typography fontWeight='bold' variant='body1'>Report URL</Typography>
                        </Box>
                        <Box className='px-2 py-3'>
                            <Typography variant='body1'>Static</Typography>
                        </Box>
                    </Box> */}
                </Box>
            </Box>
            <Box className='d-flex extra justify-content-center'>
                <Button
                    sx={{ color: 'white' }}
                    className="action-button mt-3 px-5   action-button--approve table-row-background"
                    onClick={() => handleUpdateAppliedAllocation()}
                >
                    Update
                </Button>
            </Box>
        </div>

    )
}

export default AllocationDetails